import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './SuspireCircle.module.css';
import { fetchTopBrands } from '../../api/circleAPI';

export default function TopBrands() {
  const { token } = useSelector((state) => state.user);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchTopBrands(token)
      .then((data) => { if (!cancelled) setBrands(data); })
      // Keeps whatever was last curated rather than blanking the column: an
      // empty list here reads as "no brands are featured", which is a claim we
      // cannot make from a failed request.
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [token]);

  /* The section always renders — even while loading and even with nothing curated.
     It is what keeps the feed column from stretching across the full width. */
  return (
    <aside className={styles.sidebar}>
      <h3 className={styles.sidebarTitle}>Top Brands</h3>

      {loading ? (
        <p className={styles.sidebarEmpty}>Loading brands…</p>
      ) : !brands.length ? (
        <p className={styles.sidebarEmpty}>No brands featured yet.</p>
      ) : (
        <ul className={styles.brandList}>
          {brands.map((brand) => (
            <li key={brand.id} className={styles.brandItem}>
              <div className={styles.brandLogo}>
                {brand.logo_url ? (
                  <img src={brand.logo_url} alt={brand.name || ''} />
                ) : (
                  <span>{(brand.name || '?').charAt(0)}</span>
                )}
              </div>
              <div className={styles.brandInfo}>
                <div className={styles.brandName}>{brand.name}</div>
                <div className={styles.brandDesc}>{brand.description}</div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
